import { Languages } from "src/common/descriptions/types";
import { DeleteContractDebitDescriptions } from "./types";

const DescriptionsEnUs: DeleteContractDebitDescriptions = {
    TITLE: "Delete Contract Debit Record",
    SAVE_BUTTON: "Save",
    CANCEL_BUTTON: "Cancel",
    CONFIRM_MODAL: {
        TITLE: 'Delete Contract Debit Record',
        DESCRIPTION: "Operation will not be reverted.",
        ACTION_BUTTON: "Save",
        CANCEL_BUTTON: "Go Back",
    },
    CANCEL_MODAL: {
        TITLE: "Cancel Payalbe Contract input?",
        DESCRIPTION: "All data will be lost.",
        ACTION_BUTTON: "Yes, Cancel",
        CANCEL_BUTTON: "Keep working",
    },
    SUCCESS_MODAL: {
        TITLE: "Success",
        PRIMARY_LABEL: "Accept",
        SECONDARY_LABEL: "Accept",
        DESCRIPTION: "Payable Contract Debit Deleted",
    },
    SUCCESS_SECONDARY_MODAL: {
        TITLE: "Success",
        PRIMARY_LABEL: "Accept",
        SECONDARY_LABEL: "Accept",
        DESCRIPTION: "Payable Contract Updated",
    },
    MAIN_ACTION_TITLE: "Creating Service Contract",
    MAIN_ACTION_DESCRIPTION: "Please wait...",
    FORM: {
        COMMENT: {
            LABEL: "Reason",
            PLACEHOLDER: "Input delete reason",
        },
    },
}

const DescriptionsEsUs: DeleteContractDebitDescriptions = {
    TITLE: "Eliminar Recargo de Contrato",
    SAVE_BUTTON: "Guardar",
    CANCEL_BUTTON: "Cancelar",
    CONFIRM_MODAL: {
        TITLE: 'Eliminar Débito de Contrato de Pagos',
        DESCRIPTION: "La operación no podrá ser revertida.",
        ACTION_BUTTON: "Guardar",
        CANCEL_BUTTON: "Regresar",
    },
    CANCEL_MODAL: {
        TITLE: "Cancelar ingreso de Contrato de Pagos?",
        DESCRIPTION: "La información ingresada sera borrada.",
        ACTION_BUTTON: "Si, Cancelar",
        CANCEL_BUTTON: "Seguir ingresando",
    },
    SUCCESS_MODAL: {
        TITLE: "Exito",
        PRIMARY_LABEL: "Aceptar",
        SECONDARY_LABEL: "Aceptar",
        DESCRIPTION: "Débito Contrato de Pago Eliminado",
    },
    SUCCESS_SECONDARY_MODAL: {
        TITLE: "Exito",
        PRIMARY_LABEL: "Aceptar",
        SECONDARY_LABEL: "Aceptar",
        DESCRIPTION: "Contrato de Pagos Actualizado",
    },
    MAIN_ACTION_TITLE: "Creando Categoría",
    MAIN_ACTION_DESCRIPTION: "Por favor espere...",
    FORM: {
        COMMENT: {
            LABEL: "Motivo de Eliminación",
            PLACEHOLDER: "Ingrese motivo de eliminación",
        },
    },
}

export const deleteContractDebitDictionary = {
    [Languages.ENGLISH_US]: DescriptionsEnUs,
    [Languages.SPANISH_US]: DescriptionsEsUs,
}